<template>
    <b-container class="m-0 p-0">

        <draggable v-model="policies" 
                   group="questionOptions"
                   v-bind="{handle:'.handle', animation:150}"
                   @input="updateSorting">

            <b-container v-for="(item, index) in policies"
                         :key="'policy_' + index"
                         class="p-0 mt-10">

                <hr class="hr-green-admin"/>

                <!-- Тип зависимости, удалить + передвинуть -->
                <b-row class="p-0 mt-10 v-end">

                    <b-col cols="9" class="p-0 m-0">
                        <label>
                            Тип зависимости:
                        </label>
                        <custom-multiselect required
                                            :options="relationTypes"
                                            v-model="item.RelationType"
                                            placeholder="Укажите тип зависимости" />
                    </b-col>

                    <b-col cols="2">  																
                        <b-button block
                                  @click="deleteCondition(index)"
                                  class="draggable-button red">
                            Удалить
                        </b-button>
                    </b-col>

                    <b-col cols="1" class="sort-handle handle" />

                </b-row>

                <!-- Если зависимость от вопроса -->
                <b-container v-if="item.isForQuestion()" class="p-0 mt-10">

                    <b-row class="p-0 m-0">

                        <label>
                            Вопрос:
                        </label>
                        <custom-multiselect required
                                            @select="item.onSelectParentQuestion()"
                                            :options="questions"
                                            v-model="item.ParentQuestionId"
                                            placeholder="Введите название вопроса" />

                    </b-row>

                    <!-- Условие (отображается после выбора вопроса) -->
                    <b-row v-if="item.getParentAnswerType() !== 0" class="p-0 mt-10">

                        <b-col class="p-0 mr-15" cols="4">

                            <label>
                                Условие:
                            </label>
                            <custom-multiselect required
                                                :options="item.getConditionTypes()"
                                                v-model="item.ConditionType"
                                                placeholder="Выберите условие" />

                        </b-col>

                        <!-- Для условия: "Текст совпадает с" -->
                        <b-col v-if="item.getConditionType() === 2"
                                class="p-0 mr-15 v-end"
                                cols="4">

                            <b-form-input type="text"
                                          v-model="item.Value"
                                          class="big-form-control" />

                        </b-col>

                        <!-- Для условий связанных с числами -->
                        <b-col v-if="item.isNumberAnswer() && item.getConditionType() !== 0"
                               class="p-0 m-0 v-end"
                               cols="4">

                            <b-form-input type="number"
                                          step="0.01"
                                          v-model="item.Value"
                                          class="big-form-control" />
                        </b-col>

                        <!-- Для условий связанных с выборами из списка -->
                        <b-col v-if="item.isSelectAnswer() && item.getConditionType() !== 0"
                                class="p-0 m-0 v-end"
                                cols="4">

                            <custom-multiselect required
                                                :options="getOptionsForSelect(item)"
                                                v-model="item.Value"
                                                placeholder="Вариант ответа" />
                        </b-col>

                    </b-row>

                </b-container>

                <!-- Если зависимость от ТТ -->
                <b-container v-if="item.isForTradePoint()" class="p-0 mt-10">

                    <b-row class="p-0 m-0">

                        <!-- Условие ТТ -->
                        <b-col class="p-0 mr-15" cols="5">
                            <label>
                                Условие:
                            </label>
                            <custom-multiselect required
                                                @select="changedConditionType(item)"
                                                :options="ttConditionTypes"
                                                v-model="item.ConditionType"
                                                placeholder="По полю торговой точки" />
                        </b-col>

                        <!-- ТТ является сетью (ДА/НЕТ) -->
                        <b-col v-if="item.getConditionType() === 200"
                                class="p-0 m-0 v-end"
                                cols="4">
                            <yes-no-input class="yes-no-control-big m-0"
                                          v-model="item.Value" />
                        </b-col>

                        <!-- ТТ относится к определенному типу (выбор типа ТТ) -->
                        <b-col v-if="item.getConditionType() === 201"
                                class="p-0 m-0"
                                cols="4">
                            <label>
                                Выберите тип торговой точки:
                            </label>
                            <custom-multiselect required
                                                :options="tradePointTypes"
                                                track-by="Text"
                                                label="Text"
                                                v-model="item.Value"
                                                placeholder="Тип торговой точки" />
                        </b-col>

                        <!-- ТТ относится к определенному филиалу (выбор филиала ТТ) -->
                        <b-col v-if="item.getConditionType() === 202"
                                class="p-0 m-0" cols="4">
                            <label>
                                Выберите филиал торговой точки:
                            </label>
                            <custom-multiselect required
                                                label="Name"
                                                :options="branches"
                                                v-model="item.Value"
                                                placeholder="Филиал ТТ" />
                        </b-col>

                        <!-- ТТ относится к определенному филиалу (выбор филиала ТТ) -->
                        <b-col v-if="item.getConditionType() === 203 || item.getConditionType() === 204"
                                class="p-0 m-0"
                                cols="6">
                            <label>
                                Выберите сети торговых точек:
                            </label>
                            <custom-multiselect required
                                                label="Name"
                                                :multiple="true"
                                                :options="networks"
                                                v-model="item.Value"
                                                placeholder="Сети" />
                        </b-col>
                        
                        <!-- ТТ относится к определенному региону (выбор региона ТТ) -->
                        <b-col v-if="item.getConditionType() === 206"
                                class="p-0 m-0" cols="4">
                            <label>
                                Выберите регион торговой точки:
                            </label>
                            <custom-multiselect required
                                                label="Name"
                                                :multiple="true"
                                                :options="regions"
                                                v-model="item.Value"
                                                placeholder="Регион ТТ" />
                        </b-col>

                    </b-row>

                </b-container>


            </b-container>

        </draggable>

        <b-row class="mt-13">
            <b-col cols="3" class="p-0">
                <b-button block class="draggable-button green"
                        @click="addCondition">
                    Добавить условие
                </b-button>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
import QuestionVPModel from '@/store/models/admin/questions/QuestionVisiblePolicy'
import BlockVPModel from '@/store/models/admin/blocks/BlockVisiblePolicy'

import Consts from '@/store/models/consts/adminConsts'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import YesNoInput from '@/components/shared/YesNoInput'

export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: Array,
        branches: Array,
        regions: Array,
        questions: Array,
        networks: Array,
        tradePointTypes: Array,
        questionOptions: Array,
        isBlock: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            policies: this.value,
            relationTypes: Consts.RelationTypes,
            ttConditionTypes: Consts.TradePointConditionTypes
        };
    },
    methods: {

        updateSorting: function (value) {
            this.$emit('update', value);
            this.$forceUpdate();
        },

        addCondition: function () {
            if(this.isBlock)
                this.policies.push(new BlockVPModel());
            else 
                this.policies.push(new QuestionVPModel());
                
            this.$emit('update', this.policies);
        },

        deleteCondition: function (index) {
            this.policies.splice(index, 1);
            this.$emit('update', this.policies);
        },

        updateVpItem: function () {
            this.$emit('update', this.policies);
        },

        getOptionsForSelect: function (vp) {
            return this.questionOptions.filter(qo => qo.QuestionId === vp.getParentQuestionId());
        },

        changedConditionType: function(vp) {
            vp.Value = null;
            this.$emit('update', this.policies);
        }
    },
    components: {
        CustomMultiselect,
        YesNoInput
    }
}
</script>